import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { treatments, whatsappLink } from "../mock";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";

const Treatments = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="tratamentos" className="py-20 md:py-28 bg-[#e8eaed]/60">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <span className="text-xs font-semibold tracking-widest uppercase text-[#b89a5a]">
            Tratamentos
          </span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#2f3a45] mt-4">
            Cuidado completo para a sua visão
          </h2>
          <p className="text-[#4a5a68] mt-4">
            Realizamos procedimentos dos mais simples aos de alta complexidade com
            eficiência, compromisso e agilidade.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7 mt-14">
          {treatments.map((t) => (
            <button
              key={t.id}
              onClick={() => setActive(t)}
              className="reveal group text-left bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1.5"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={t.image}
                  alt={t.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2f3a45]/40 to-transparent" />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-display font-semibold text-xl text-[#2f3a45] group-hover:text-[#b89a5a] transition-colors">
                    {t.title}
                  </h3>
                  <ArrowUpRight className="w-5 h-5 text-[#94a7b8] group-hover:text-[#b89a5a] transition-colors shrink-0 mt-1" />
                </div>
                <p className="text-[#6b7a88] mt-2 text-sm leading-relaxed">{t.short}</p>
                <span className="inline-block mt-4 text-sm font-semibold text-[#b89a5a]">
                  Saiba mais
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-lg p-0 overflow-hidden gap-0">
          {active && (
            <>
              <img src={active.image} alt={active.title} className="w-full h-56 object-cover" />
              <div className="p-7">
                <DialogHeader>
                  <DialogTitle className="font-display text-2xl text-[#2f3a45]">
                    {active.title}
                  </DialogTitle>
                </DialogHeader>
                <div className="gold-line mt-3 mb-4" />
                <p className="text-[#4a5a68] leading-relaxed">{active.description}</p>
                <Button
                  asChild
                  className="mt-6 w-full bg-[#b89a5a] hover:bg-[#a5884b] text-white rounded-full"
                >
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                    Agendar avaliação
                  </a>
                </Button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Treatments;
